import React from "react";
import { getLineUpData } from "../../utils/extractConfigData";
import Grid from "../Grid";
import GridLayouts from "../../utils/GridLayouts";
import BandComponent from "../BandComponent";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';

import styles from "./LineUp.module.css";

const LineUp = () => {
  const lineUpData = getLineUpData();

  if (!lineUpData.enabled) return "";

  // Filter en sorteer de bands per podium
  const mainstageBands = lineUpData.bands
    .filter(band => band.podium === "Mainstage")
    .sort((a, b) => a.order - b.order);

  const lokaalBands = lineUpData.bands
    .filter(band => band.podium === "LOKAAL IN'T LOKAAL")
    .sort((a, b) => a.order - b.order);

  const lokaalHost = lineUpData.lokaalHost;

  return (
    <section id="line-up" className={styles.section}>
      <div className={styles.container}>
        <div className={styles.content}>
          <p className={styles.title}>{lineUpData.title}</p>
          
          <h2 className={styles.podiumTitle}>MAINSTAGE</h2>
          <Grid layout={GridLayouts.TWO_COLUMN}>
            {mainstageBands.map((data, index) => (
              <BandComponent key={`mainstage-${index}`} data={data} />
            ))}
          </Grid>
          
          <h2 className={styles.podiumTitle}>LOKAAL IN'T LOKAAL</h2>
          <div className={styles.lokaalDescription}>
            {(lineUpData.lokaalDescription ?? []).map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
            {lokaalHost && (lokaalHost.facebook || lokaalHost.instagram) && (
              <div className={styles.lokaalLinks}>
                {lokaalHost.facebook && (
                  <a href={lokaalHost.facebook} className={styles.lokaalLink} target="_blank" rel="noopener noreferrer" aria-label={`${lokaalHost.name} op Facebook`}>
                    <FontAwesomeIcon icon={faFacebook} size="2x" />
                  </a>
                )}
                {lokaalHost.instagram && (
                  <a href={lokaalHost.instagram} className={styles.lokaalLink} target="_blank" rel="noopener noreferrer" aria-label={`${lokaalHost.name} op Instagram`}>
                    <FontAwesomeIcon icon={faInstagram} size="2x" />
                  </a>
                )}
              </div>
            )}
          </div>
          <Grid layout={GridLayouts.TWO_COLUMN}>
            {lokaalBands.map((data, index) => (
              <BandComponent key={`lokaal-${index}`} data={data} />
            ))}
          </Grid>
        </div>
      </div>
    </section>
  );
};

export default LineUp;
